<template>
  <section id="app-scan-nfc">
    <div class="bloc-action">
      <div class="d-flex">
        <img
          :src="AppImages.swipe"
          alt="swipe_logo"
          class="ma-auto"
          width="210"
          height="170"
        >
      </div>

      <p class="text-center title">
        {{ $t('field.scan.thx_presenting') }}<br>
        {{ action === 0 ? $t('field.scan.ur_support') : $t('field.scan.ur_payment') }}
      </p>

      <bottom-action
        :btn-del="deletable"
        :btn-del-disabled="action > 22 || action === ActionEnum.credit"
        :btn-cancel="cancellable"
        :btn-cancel-disabled="(action === ActionEnum.credit && total > 0)"
        :btn-valid="action === ActionEnum.credit"
        :btn-valid-disabled="(action === ActionEnum.credit && total === 0)"
        :use-listener="false"
        @del="$emit('del')"
        @cancel="$emit('cancel')"
        @valid="$emit('valid')"
      />
    </div>
  </section>
</template>

<script>
import { ActionEnum, IconEnum, SCAN_TYPE } from '@/modules/Enums'
import { AppImages } from '@/modules/Images'
import { $alert } from '@/modules/Utils'

export default {
  name: 'SwipeScan',

  props: {
    action: { type: Number, default: null },
    cancellable: { type: Boolean, default: true },
    deletable: { type: Boolean, default: true },
    locked: { type: Boolean, default: false },
    resetScan: { type: Boolean, default: false },
    total: { type: Number, default: 0 }
  },

  data () {
    return {
      ActionEnum,
      IconEnum,
      AppImages,
    }
  },

  watch: {
    resetScan () {
      if (IS_PAX) {
        setTimeout(this.stopPaxSwipe , 500)
        setTimeout(this.startPaxSwipe , 2500)
      }
    }
  },

  mounted () {
    if (IS_PAX) {
      this.startPaxSwipe()
    }
    // else if (IS_DESKTOP) {
    //   window.addEventListener('keypress', this.receiveDesktopNfc, false)
    // }
    else {
      $alert('Lecteur à piste indisponible')
      this.$emit('to-keyboard', true)
    }
  },

  beforeDestroy () {
    if (IS_PAX) {
      this.stopPaxSwipe()
    }
    // else if (IS_DESKTOP) {
    //   window.removeEventListener('keypress', this.receiveDesktopNfc, false)
    // }
  },

  methods: {
    startPaxSwipe () {
      Pax.startSwipe(
        (uid) => {
          this.$emit('scan', uid.substring(0, uid.indexOf('=')), SCAN_TYPE.SWIPE)
        }, (error) => {
          $alert(error)
        }
      )
    },
    stopPaxSwipe () {
      Pax.stopSwipe()
    }
  }
}
</script>

<style scoped>
img {
  -webkit-filter: invert(1);
  filter: invert(1);
}
</style>
